<script lang="ts" setup>
import { getAdres } from '@services/crm-public/postcodeService';
import AdresField from '@shared/form/AdresField/AdresField.vue';
import { useAdresFieldProps } from '@shared/form/AdresField/useAdresFieldProps';
import FieldRowV2 from '@shared/form/FieldRowV2/FieldRowV2.vue';
import { inject, ref } from 'vue';
import {
  hideRequiredAsteriskInjectionKey,
  isDisabledInjectionKey,
  isReadonlyInjectionKey,
} from '../keys';

const { value: hasDisabledParent } = inject(isDisabledInjectionKey, { value: ref(false) });
const { value: hasReadonlyParent } = inject(isReadonlyInjectionKey, { value: ref(false) });
const { value: hideRequiredAsteriskParent } = inject(hideRequiredAsteriskInjectionKey, {
  value: ref(false),
});

const fieldId = 'relatiegegevens-relatie-adres';
const { errors, adresFieldPaths } = useAdresFieldProps();
</script>

<template>
  <FieldRowV2
    label="Adres"
    :required="!hideRequiredAsteriskParent && !hasReadonlyParent"
    :label-for="fieldId"
    :errors="errors"
    v-bind="$attrs"
  >
    <AdresField
      :disabled="hasDisabledParent"
      :readonly="hasReadonlyParent"
      :lookup="getAdres"
      :id="fieldId"
      :adres-field-paths
    />
  </FieldRowV2>
</template>
